import { ClaudeTemplate } from "../types";

/** Amazon DSP: Prime Video, Twitch y resto de inventario de Amazon. */
export const amazonDspTemplate: ClaudeTemplate = {
  id: "amazon-dsp",
  tool: "Amazon DSP",
  url: "https://advertising.amazon.com/dsp",
  hierarchy:
    'Entity (cuenta DSP) → Advertiser → Campaign (antes "Order") → Ad group (antes "Line item") → Creatives',
  idHint:
    "columna ID de la lista de campañas o número que aparece en la URL al abrir la campaña",
  accountField: "amazonAdvertiserIds",
  steps: `
### 1. Entrar en el advertiser (puede que ya estés dentro)
1. Abre Amazon Ads ({{url}}) y entra en **Amazon DSP**. Si ya está abierto, sigue.
2. Si se pide, elige la **Entity** (cuenta DSP) de la agencia.
3. Entra en el **Advertiser** del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscalo por nombre; si hay varios candidatos, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, crea una campaña nueva ("Create campaign"):
   - Name: {{names.order}}
   - Goal / KPI: el que encaje con {{goal.kpi}} (CPM → awareness / reach; CPC → consideration / clicks; CPV → video completion).
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}}.
   - Country / marketplace: {{goal.country}}.
   - Frequency cap: por defecto, salvo que las notas digan otra cosa.
3. Guarda sin lanzar (borrador).

### 3. Ad group
1. Dentro de la campaña, crea un ad group:
   - Name: {{names.line}}
   - Tipo de inventario: el que digan las notas de esta línea (Streaming TV / Prime Video, Twitch, Online video, Display…). Si no queda claro, pregunta.
   - Fechas: las de la campaña.
   - Budget: el de la campaña ({{goal.budget}}) salvo que las notas indiquen otro reparto.
   - Bid: base / max bid en torno a {{goal.netUnitCost}}.
2. Targeting (solo lo que venga en el briefing):
   - Geografía: {{target.geography}}.
   - Demografía: {{target.gender}}, {{target.age}}.
   - Audiencias de Amazon / de datos: {{target.audience}}. Intereses / in-market: {{target.interests}}.
   - Dispositivos: {{target.technology}}.
   - Exclusiones: {{target.exclusions}}.
3. Guarda sin activar.

### 4. Creatives
1. Mira si las creatividades ya están subidas en el advertiser. Si están, asígnalas al ad group.
2. Si no están, súbelas desde los enlaces del bloque "Creatividades" (vídeo para Streaming TV / Twitch). Si un enlace no abre, para y avísame.
3. Click-through / landing con UTM: bloque "URLs de destino" (en Streaming TV puede no aplicar).
4. Las creatividades pasan por moderación de Amazon: es normal que queden pendientes.
`,
};
